import DateUtils from '@shared/utils/date';
import Separator from '@components/atoms/text/descriptionDotSeparator';
import Text from '@components/atoms/text/catchupAvailabilityText';
import TranslationManager from '@shared/assets/locale/translationsManager';
import EmptyContainer from '@components/atoms/container/emptyContainer';

interface Props {
  date?: number;
  displaySeparator?: boolean;
}

export default function CatchupAvailability({ date, displaySeparator }: Props) {
  if (!date) return;
  const endDate = new Date(date);
  endDate.setUTCDate(endDate.getUTCDate() + 7);

  return (
    <EmptyContainer id={'catchupContainer'}>
      {displaySeparator ? <Separator /> : null}
      <Text>
        {TranslationManager.get('COMPONENTS.DESCRIPTION.AVAILABLE_UNTIL')}
        {DateUtils.getTime({
          customDate: endDate.getTime(),
          displaySeconds: false,
          displayMinutes: false,
          displayHours: false,
          displayDay: true,
          displayMonth: true,
          displayYear: true,
          separator: ' ',
          trimMonth: true,
        })}
      </Text>
    </EmptyContainer>
  );
}
